import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";

import ProductionitemStatusesService from "../_services/productionitem/ProductionitemStatusesService";
import ProductionjobListService from "../_services/productionjob/ProductionjobListService";

const ScheduleProductionitemsComponent = (props) => {

  const {t} = props;
  const [scheduleProductionitems, setScheduleProductionitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderScheduleProdictionitems: false})
      let _lazyParams = {
        ...lazyParams,
        filters: {
          schedule: {
            value: window.App.state.props.id
          }
        }
      }
      ProductionjobListService(JSON.stringify(_lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setScheduleProductionitems(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })

      // ScheduleProductionitemsService(JSON.stringify(lazyParams), props.scheduleId)
      //   .then(response => {
      //     setTotalRecords(response.data.total_item_count);
      //     setScheduleProductionitems(response.data.items);
      //     setLoading(false);
      //   })
      //   .catch(error => {
      //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      //   })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*{/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const [statuses, setStatuses] = useState([]);
  const status = (rowData) => {
    if (statuses && statuses[0]) {
      let status_ = statuses.filter(item => item.id === rowData.status)
      if (status_[0] && status_[0].name) {
        return status_[0].name
      }
    }
  }

  useEffect(() => {
    ProductionitemStatusesService()
      .then((response) => {
        setStatuses(response.data)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderScheduleProdictionitems === true])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={scheduleProductionitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
      >
        {/*<Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>*/}
        <Column field="status" header="Státusz" sortable body={status}></Column>
        <Column field="projectName" header={t('project')} sortable filter filterPlaceholder={t('project')}></Column>
        <Column field="projectItemNumber" header="Munkaszám" sortable filter filterPlaceholder="Munkaszám"></Column>
        <Column field="technologyName" header="Technológia" sortable filter filterPlaceholder="Technológia"></Column>
        <Column field="machineName" header="Gép" sortablefilter filterPlaceholder="Gép"></Column>
        <Column field="employeeName" header="Munkavállaló" sortable filter filterPlaceholder="Munkavállaló"></Column>
        <Column field="estimatedTime" header="Becsült" sortable body={(rowData) => {
          return (
            <>
              {rowData.estimatedTime &&
              <>{rowData.estimatedTime} perc</>
              }
            </>
          )
        }}></Column>
        <Column field="producedTime" header="Valós" sortable body={(rowData) => {
          return (
            <>
              {rowData.producedTime &&
              <>{rowData.producedTime} perc</>
              }
            </>
          )
        }}></Column>
        <Column field="mainTime" header="Főidő" sortable body={(rowData) => {
          return (
            <>
              {rowData.mainTime &&
              <>{rowData.mainTime} perc</>
              }
            </>
          )
        }}></Column>
        <Column field="auxiliaryTime" header="Mellékidő" sortable body={(rowData) => {
          return (
            <>
              {rowData.auxiliaryTime &&
              <>{rowData.auxiliaryTime} perc</>
              }
            </>
          )
        }}></Column>
        <Column field="quantity" header="Mennyiség" className={"p-text-right"} alignHeader="right" body={(rowData) => {
          return (
            <>
              {rowData.quantity} {rowData.unitName}
            </>
          )
        }}></Column>
        {/*<Column field="dateUntil" header="Időpontig" sortable className={"p-text-nowrap"} body={(rowData) => {*/}
        {/*  return (*/}
        {/*    <>{moment.utc(rowData.dateUntil).local().format('YYYY-MM-DD HH:mm')}</>*/}
        {/*  )*/}
        {/*}}></Column>*/}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ScheduleProductionitemsComponent);
